import React from "react";

export default function NotValidFieldColumn({ columnList }) {
  return (
    <div className="not-valid-column-container">
      <h2 className="title">Configuration Needed</h2>
      <p>
        Please configure the below attributes from data configuration to enable
        the filtration:
      </p>
      <div className="column-list">
        {columnList.map((column, index) => (
          <React.Fragment key={index}>
            <span className="column-name">{column}</span>
            {index < columnList.length - 1 && (
              <span className="arrow"> &rarr; </span>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
